import { BankerRepoImpl } from "domain/repository/Banker/BankerRepoImpl";
import { ChargeDetailRepoImpl } from "domain/repository/ChargeDetailMaintenance/ChargeDetailRepoImpl";
import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { CounterCustomerChargeRepoImpl } from "domain/repository/CounterCustomerCharge/CounterCustomerChargeRepoImpl";
import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { OpsLineRepoImpl } from "domain/repository/OpsLine/OpsLineRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { RequestServiceCodeRepoImpl } from "domain/repository/RequestServiceCode/RequestServiceCodeRepoImpl";
import { StandardTariffCodeRepoImpl } from "domain/repository/TariffCode/StandardTariffCodeRepoImpl";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { CounterCustomerChargeMaintenanceVM } from "presentation/viewModel/CounterCustomerCharge/CounterCustomerChargeMaintenanceVM";
import { useMemo } from "react";

export const useCounterCustomerChargeMaintenanceVM = () => {
    const [, setCounterCustomerChargeMaintenanceState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeMainVM = useMemo(() =>
        CounterCustomerChargeMaintenanceVM({
            dispatch: [setCounterCustomerChargeMaintenanceState],
            repo: CounterCustomerChargeRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            opsLineRepo: OpsLineRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            standardTariffCodeRepo: StandardTariffCodeRepoImpl(),
            requestServiceCodeRepo: RequestServiceCodeRepoImpl(),
            bankerRepo: BankerRepoImpl(),
            chargeDetail: ChargeDetailRepoImpl(),
        }), [setCounterCustomerChargeMaintenanceState])

    return counterCustomerChargeMainVM
}

